import { motion } from 'motion/react';
import { snappyTween } from './motionUi';

/**
 * Contract Addendum — shown when relationship tier changes with a dominant character.
 * Informational only — can only be accepted, not dismissed.
 */
export default function ContractAddendumModal({
  characterName = '',
  fromTier = '',
  toTier = '',
  newTitles = [],
  onAccept
}) {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/85 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: 'spring', damping: 22, stiffness: 280 }}
        className="w-full max-w-lg overflow-hidden rounded-2xl border border-game-accent/30 bg-game-canvas shadow-2xl"
      >
        <div className="border-b border-white/10 bg-game-popup/40 px-6 py-4 text-center">
          <h2 className="text-lg font-bold tracking-tight text-game-accent">Contract Addendum</h2>
        </div>

        <div className="space-y-4 px-6 py-5">
          <p className="text-center text-sm leading-relaxed text-game-body">
            Due to the change in relationship with{' '}
            <span className="font-bold text-game-accent">{characterName}</span>{' '}
            from <span className="font-semibold text-game-muted line-through">{fromTier}</span>{' '}
            to <span className="font-bold text-game-text">{toTier}</span>,
            I agree to new titles and promise to serve her even better.
          </p>

          {newTitles.length > 0 ? (
            <div>
              <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-game-muted">New Titles</p>
              <div className="flex flex-wrap gap-2">
                {newTitles.map((t, i) => (
                  <span
                    key={i}
                    className="rounded-lg border border-game-accent/30 bg-game-accent/15 px-3 py-1.5 text-xs font-semibold text-game-accent"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          ) : null}
        </div>

        <div className="border-t border-white/10 px-6 py-4">
          <motion.button
            type="button"
            transition={snappyTween}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onAccept}
            className="w-full rounded-xl bg-game-accent py-3 text-sm font-bold text-game-accentText"
          >
            I Accept
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
}
